import Lottie from 'lottie-react';

import lottieEmptyReport from '../jsons/member-report-empty.json';

const LottieMemberReportEmpty = props => {
  return <Lottie animationData={lottieEmptyReport} loop={false} {...props} />;
};

export default LottieMemberReportEmpty;
